module.exports = __webpack_public_path__ + "img/alice.5a9b42b7.png";